import { ConnectorImage } from "./ConnectorImage";
import { type AIProviderId, getAIProvider } from "../../shared/aiProviders";
import { openAICompatibleConnectorProviderLogos } from "../../shared/aiProviders/openaiCompatible/connectorProviders";
import threeBLogo from "../../shared/connectors/3bAi/logo.svg";
import claudeLogo from "../../shared/connectors/anthropic/claude.svg";
import databricksLogo from "../../shared/connectors/databricks/logo.svg";
import snowflakeLogo from "../../shared/connectors/snowflake/logo.svg";
import apiKeyLogo from "../../shared/connectors/apiKey/logo.svg";
import awsBedrockLogo from "../../shared/connectors/awsBedrock/logo.svg";
import geminiLogo from "../../shared/connectors/googleGemini/gemini.svg";
import azureLogo from "../../shared/connectors/microsoftAzure/logo.svg";
import microsoftFoundryLogo from "../../shared/connectors/microsoftFoundry/logo.svg";
import openaiLogo from "../../shared/connectors/openai/logo.svg";
import oracleOciLogo from "../../shared/connectors/oracleOci/logo.svg";

const providerLogos: Record<AIProviderId, string> = {
  "3b": threeBLogo,
  anthropic: claudeLogo,
  databricksAiGateway: databricksLogo,
  snowflakeCortexAiGateway: snowflakeLogo,
  "bedrock-anthropic": claudeLogo,
  awsBedrock: awsBedrockLogo,
  awsBedrockMantle: awsBedrockLogo,
  awsBedrockMantleAnthropic: awsBedrockLogo,
  openai: openaiLogo,
  "openai-compatible": apiKeyLogo,
  azure: azureLogo,
  googleGemini: geminiLogo,
  googleVertex: geminiLogo,
  "microsoft-foundry": microsoftFoundryLogo,
  "oracle-oci": oracleOciLogo,
  ...openAICompatibleConnectorProviderLogos,
};

export function ProviderLogo({
  provider,
  size = 16,
  onDark = false,
}: {
  provider: AIProviderId;
  size?: number;
  onDark?: boolean;
}) {
  return (
    <ConnectorImage
      alt={getAIProvider(provider).label}
      src={providerLogos[provider]}
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        // Logos use a theme-adaptive fill, so force them white on the always-dark
        // strip to stop them flipping per theme.
        ...(onDark && { filter: "brightness(0) invert(1)" }),
      }}
    />
  );
}
